import React, { useState, useContext } from 'react';
import { TextField, Button } from "@mui/material";
import Message from '../modal/message';
import { LanguageContext } from './content';

function Index () {
    const [registrationData, setRegistrationData] = useState({
            code: '',
            email: ''
    })
    const [showModalMessage, setShowModalMessage] = useState(false)
    const [modalMessageText, setModalMessageText] = useState("")
    const [modalMessageType, setModalMessageType] = useState(1)
    const {language, setLanguage} = useContext(LanguageContext)
    
    function handleCloseModalMessage() {
        if (modalMessageType === 1) {
            setModalMessageText("")
            setShowModalMessage(false)
        } else {
            setModalMessageText("")
            setShowModalMessage(false)
        }
    }
    
    function handleChange(event) {
        const regEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        const name = event.target.name;
        const value = event.target.value;
        const id = event.target.id;
        if (name === 'code') {
            if (value === '') {
                document.getElementById('block-' + name).classList.add('error');
            } else {
                document.getElementById('block-' + name).classList.remove('error');
                setRegistrationData({...registrationData, [name]: value})
            }
        } else if (name === 'email') {
            if (value === '' || regEmail.test(value) === false) {
                document.getElementById('block-' + name).classList.add('error');
            } else {
                document.getElementById('block-' + name).classList.remove('error');
                setRegistrationData({...registrationData, [name]: value})
            }
        }
    }

    function handleSubmit() {
        if (registrationData.code === '') {
            document.getElementById('block-code').classList.add('error')
        }
        if (registrationData.email === '') {
            document.getElementById('block-email').classList.add('error')
        }

        if (!document.getElementById('block-code').classList.contains('error') && !document.getElementById('block-email').classList.contains('error')) {            
            const formData = new FormData();
            formData.append('code', registrationData.code)
            formData.append('email', registrationData.email)

            const responseData = Object.fromEntries(formData.entries())

            fetch("/json/form/registrationCode", {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(responseData),
                headers: {
                    "X-XSRF-TOKEN": document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
                    "Content-Type": "application/json"
                }
            }).then((response) => {
                return response.json()
            }).then((resp) => {
                if (resp.result === 1) {
                    setRegistrationData({
                        code: '',
                        email: ''
                    })
                    document.getElementById('code').value = null;
                    document.getElementById('email').value = null;
                    setModalMessageType(1)
                    setShowModalMessage(true)
                    setModalMessageText(resp.msg)
                } else {
                    setModalMessageType(-1)
                    setShowModalMessage(true)
                    setModalMessageText(resp.msg)
                }
            }, (error) => {

            })
        }
    }

    return (
            <>
            <div class="container-fluid">
                <div class="row">
                    <div class="wrapper">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="content">
                                            <h1>{language == 'eng' ? 'CHECK LICENSE' : 'ПРОВЕРИТЬ ЛИЦЕНЗИЮ'}</h1>
                                            <div className="block-input" id="block-code">
                                                <TextField label={language == 'eng' ? 'Enter a code' : 'Введите код'} variant="standard" id="code" name="code" onChange={handleChange} onClick={handleChange}/>
                                            </div>
                                            <div className="block-input" id="block-email">
                                                <TextField label={language == 'eng' ? 'E-mail' : 'Электронная почта'} variant="standard" id="email" name="email" onChange={handleChange} onClick={handleChange}/>
                                            </div>
                                            <button type="submit" onClick={handleSubmit}>{language == 'eng' ? 'SEARCH' : 'ПОИСК'}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Message showModalMessage={showModalMessage} modalMessageText={modalMessageText} handleCloseModalMessage={handleCloseModalMessage}/>
            </>
            )
}

export default Index
